<template>
<modal
	class="integration-modal"
	size="medium"
	@close="closeModal"
>
	<template slot="header">
		<h3>{{ title }}</h3>
	</template>
	<template slot="body">
		<div class="form-group">
			<div
				class="alert alert-info"
				role="alert"
			>
				{{ alertText }}
			</div>
			<!-- Store Nickname -->
			<label class="font-weight-bold">
				{{ $t('Store Nickname') }}
			</label>
			<input
				type="text"
				:class="{ 'form-error': !isValidStoreLabel }"
				class="form-control"
				v-model="storeLabel"
				required
			/>
			<span
				v-if="!isValidStoreLabel"
				class="small is-error"
			>
				{{ $t('omnichannel.validate.storelabel') }}
			</span>

			<!-- Store Url -->
			<div
				v-if="omniType === 'Tokopedia'"
				class="mt-2"
			>
				<label class="font-weight-bold">
					{{ $t('Url Store') }}
				</label>
				<input
					id="urlstore"
					type="text"
					:class="{ 'form-error': !isValidStoreUrl }"
					class="form-control"
					v-model="storeUrl"
					required
				/>
				<span
					v-if="!isValidStoreUrl"
					class="small is-error"
				>
					{{ $t('omnichannel.validate.storeurl') }}
				</span>
			</div>
			<div>
				<small class="mt-2">{{ $t(`When you click “connect”\, we will direct you to ${omniType} and you will be asked to log in to your account`) }}</small>
			</div>
		</div>
		<button
			id="btn-connect-store"
			type="button"
			class="btn btn-primary"
			:class="{ 'is-loading': isConnectingAccount }"
			:disabled="!isValidForm"
			@click="connectNewStore(omniChannelType)"
		>
			{{ $t('Connect Store') }}
		</button>
		<div
			class="alert alert-success mt-3"
			role="alert"
		>
			{{ $t('We do not store your account and password. The password you input will be used to access the Marketplace')}}
		</div>
	</template>
	<template slot="footer">
		<button
			id="btn-close"
			type="button"
			class="btn btn-default"
			@click="closeModal"
		>
			{{ $t('Cancel') }}
		</button>
	</template>
</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'MarketplaceAddStoreForm',
	components: {
		Modal,
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		alertText: {
			type: String,
			default: '',
		},
		omniType: {
			type: String,
			default: '',
		},
		omniChannelType: {
			type: String,
			default: 'shopee',
		},
		isConnectingAccount: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			storeLabel: '',
			storeUrl: '',
			isValidStoreLabel: true,
			isValidStoreUrl: true,
		};
	},
	computed: {
		isValidForm() {
			const storeLabel = this.storeLabel ? this.storeLabel.trim() : '';
			const storeUrl = this.storeUrl ? this.storeUrl.trim() : '';

			let isValid = storeLabel !== '';
			if (this.omniType === 'Tokopedia') {
				isValid = isValid && storeUrl !== '';
			}
			return isValid;
		},
	},
	mounted() {
		this.clearForm();
	},
	methods: {
		connectNewStore(type = 'shopee') {
			const storeLabel = this.storeLabel ? this.storeLabel.trim() : '';
			const storeUrl = this.storeUrl ? this.storeUrl.trim() : '';
			this.validateForm(storeLabel, storeUrl);

			const store = {
				type,
				storeLabel,
				storeUrl,
			};

			if (this.isValidForm) {
				this.$emit('submit', store);
			}
		},
		validateForm(storeLabel, storeUrl) {
			this.isValidStoreLabel = storeLabel !== '';
			this.isValidStoreUrl = storeUrl !== '';
		},
		closeModal() {
			this.$emit('close');
		},
		clearForm() {
			this.storeLabel = '';
			this.storeUrl = '';
			this.isValidStoreLabel = true;
			this.isValidStoreUrl = true;
		},
	},
};
</script>
